import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.94969 14.0003C5.91959 14.0003 5.88879 13.9961 5.85869 13.9884C5.70609 13.9471 5.59969 13.8085 5.59969 13.6503V8.40028H0.349687C0.191487 8.40028 0.0528874 8.29388 0.0115874 8.14128C-0.0297126 7.98868 0.0374874 7.82698 0.173987 7.74788L13.474 0.0478774C13.6112 -0.0312226 13.7848 -0.00882258 13.8968 0.103177C14.0088 0.215177 14.0319 0.388777 13.9521 0.525977L6.25209 13.826C6.18839 13.9359 6.07149 14.0003 5.94899 14.0003H5.94969ZM1.65309 7.70028H5.94969C6.14289 7.70028 6.29969 7.85708 6.29969 8.05028V12.3469L12.6893 1.31068L1.65309 7.70028Z'
      fill='#0D0D0D'
    />
  </svg>
)
